import { render } from "./SearchProduct.vue?vue&type=template&id=032e282b"
import script from "./SearchProduct.vue?vue&type=script&lang=js"
export * from "./SearchProduct.vue?vue&type=script&lang=js"

import exportComponent from "/Users/robo1/Documents/Admin/admv5-php/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__